module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "add-lesson__header",
    style: ({
      'backgroundColor': _vm.color ? _vm.color : '#2c81ba'
    })
  }, [_c('h2', [_vm._v("Opret fag i " + _vm._s(_vm.theCreateSubject.klassebetegnelse))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "add-lesson__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Titel*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "inputTitle",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Fagkode*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fagkode),
      expression: "fagkode"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fagkode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.standardSubjects), function(fag) {
    return _c('option', {
      key: fag.fagkode,
      domProps: {
        "value": fag.fagkode
      }
    }, [_vm._v("\n            " + _vm._s(fag.fagkode) + ": " + _vm._s(fag.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Klassetimer på året*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.klokketimer),
      expression: "klokketimer"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.klokketimer)
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.klokketimer = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__submit"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [_c('button', {
    staticClass: "marg-1-right bg-white",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isFormValid) ? _c('div', {
    staticClass: "hint--top-left",
    attrs: {
      "aria-label": "Udfyld formularen"
    }
  }, [_c('button', {
    staticClass: "submit-button submit-button--disabled"
  }, [_vm._v("Opret")])]) : _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Opret")])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58eff32a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningKlasserFagForm.vue
// module id = 1938
// module chunks = 1